import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { CustomEventService } from "@shared/services/custom-event.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import ActionTypesEnum from "@shared/enums/action-constant.enum";
import { validateFormGroup } from "@shared/utils/form.util";
import { PropertiesService } from "@core/services/properties.service";

@UntilDestroy()
@Component({
  selector: 'app-exclude-pr-modal',
  templateUrl: './exclude-pr-modal.component.html'
})
export class ExcludePRModalComponent implements OnInit,OnDestroy {

  @Input() analysisId: string;
  @Input() pullRequestId: string;


  excludeForm: FormGroup;

  constructor(private fb: FormBuilder,
              public propertiesService: PropertiesService,
              private customEventService: CustomEventService) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    const reason = '';

    this.excludeForm = this.fb.group({
      reason: [reason, [Validators.required]],
      exclude: [true],
    });
  }

  submitForm(): void {
    validateFormGroup(this.excludeForm);

    if (this.excludeForm.invalid) {
      return;
    }

    const formData = {
      ...this.excludeForm.value,
      analysisId: this.analysisId,
      pullRequestId: this.pullRequestId
    };
    this.customEventService.announceEvent(ActionTypesEnum.EXCLUDE_PR, formData);
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  ngOnDestroy(): void {}

}

